export default [
  {
    label: 'Arts',
    value: 'arts',
  },
  {
    label: 'Business',
    value: 'business',
  },
  {
    label: 'Educational',
    value: 'educational',
  },
  {
    label: 'Film',
    value: 'film',
  },
  {
    label: 'Food & Drink',
    value: 'food-and-drink',
  },
  {
    label: 'Health',
    value: 'health',
  },
  {
    label: 'Music',
    value: 'music',
  },
  {
    label: 'Nightlife',
    value: 'nightlife',
  },
  {
    label: 'Social',
    value: 'social',
  },
  {
    label: 'Sports & Outdoors',
    value: 'sports-and-outdoors',
  },
  {
    label: 'Theatre & Dance',
    value: 'theatre-and-dance',
  },
  {
    label: 'Tourism',
    value: 'tourism',
  }
];



// WEBPACK FOOTER //
// ./src/constants/categories.js